<template>
  <div class="py-3 compilatore-questionario">
    <div v-if="template" class="">
      <CompilatoreQuestionarioInBlocks
        v-if="template.block_number > 1"
        :patient="patient"
        :survey="template"
        v-on:filled-form="sendForm($event)"
      />
      <CompilatoreQuestionarioInLine
        v-else
        :patient="patient"
        :survey="template"
        v-on:filled-form="sendForm($event)"
      />
    </div>
  </div>
</template>
<script>
import CompilatoreQuestionarioInBlocks from "@/app/modules/servizi/screening/components/compilatore/CompilatoreQuestionarioInBlocks.vue";
import CompilatoreQuestionarioInLine from "@/app/modules/servizi/screening/components/compilatore/CompilatoreQuestionarioInLine.vue";
import { matchesResponse } from "@/_utils/survey_flow";
export default {
  name: "CompilatoreQuestionario",
  props: ["survey", "patient"],
  components: {
    CompilatoreQuestionarioInBlocks,
    CompilatoreQuestionarioInLine,
  },
  data() {
    return {
      template: null,
      consent: false,
      proceed: false,
      file: null,
      tempTag: null,
      hasFocus: null,
      schemaRicognizione: null,
      schemaRicognizionePatologie: null,
    };
  },
  methods: {
    onFileChange(e) {
      this.file = e.target.files[0];
    },
    sendForm() {
      this.$emit("filled-form", this.template);
    },
    handleUpload(data, ind) {
      if (this.template.template.domande[ind].a == null) {
        this.template.template.domande[ind].a = [];
      }
      this.template.template.domande[ind].a.push(data.hashid);
      if (Array.isArray(data)) {
        this.template.template.domande[ind].a = data.map((el) => el.hashid);
      }
    },
    removeUpload(ind) {
      this.template.template.domande[ind].a = null;
    },
    addCustom(ind) {
      this.template.template.domande[ind].a.push(this.tempTag);
      this.tempTag = null;
    },
    setRicognizioneQuestions(data) {
      this.schemaRicognizione = data;
    },
    setRicognizionePatologieQuestions(data) {
      this.schemaRicognizionePatologie = data;
    },
    canBeShown(domanda) {
      if (!domanda.si && !domanda.hi) {
        return true;
      }
      // Confronto per inclusione: gestisce le multiselect (risposta array)
      if (
        domanda.si &&
        matchesResponse(
          this.template.template.domande[domanda.si.index].a,
          domanda.si.response
        )
      ) {
        return (
          !domanda.hi ||
          (domanda.hi &&
            !matchesResponse(
              this.template.template.domande[domanda.hi.index].a,
              domanda.hi.response
            ))
        );
      }
      return false;
    },
  },
  created() {
    if (this.survey) {
      this.template = this.survey;
      try {
        var parsed = JSON.parse(this.survey.template);
        this.template.template = parsed;
      } catch {
        //
      }
    }
  },
};
</script>

<style scoped>
/* il compilatore non deve allargare i container della pagina quando e' figlio di contenitori flex */
.compilatore-questionario {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
</style>